/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
const cardsAnimationTiming = 300;
document.addEventListener('DOMContentLoaded', (event) => {
    initRecaptcha();
    jsLazyLoadImages();
    initFormsValidation();
    initModalResponse();
    initIubendaProof();
    initLoadMore();
    initFilter();
    initVideo();
    initMapScript();
    initMegaMenu();
    initCardsAnimation(cardsAnimationTiming);
    initTextGalleryAccordionBlockWidget();
    initPagesSliderWidget();
    initHomepageHeading();
    initImageAccordion();
    initAccordion();
    initRelatedPostsSliderWidget();
    initSectorListingByCategory();
    initTipleBlockBanner();
    initAttachedFile();
    initPersonalizedFormCarousel();
    initToggler();
    initCWV();
});
